/* eslint-disable no-nested-ternary */
import React, { ChangeEvent } from "react"
import Checkbox from "@material-ui/core/Checkbox"
import FormHelperText from "@material-ui/core/FormHelperText"
import { FormikTouched } from "formik"
import clsx from "clsx"
import { AppLinkMui } from "@ecom/ui/components/AppLink"
import { WrapperDataLayer } from "./WrapperDataLayer"

import { CheckIcon } from "../icons/CheckIcon"
import { EmptyIcon } from "../icons/EmptyIcon"

import * as styles from "./fields.module.scss"
import type { TFormVariant } from "../../types"
import { CheckIconPink } from "../icons/CheckedPink"
import { EmptyIconPink } from "../icons/EmptyIconPink"
import { EmptyIconPravdaCoffee } from "../icons/EmptyIconPravdaCoffee"
import { FilledIconPravdaCoffee } from "../icons/FilledIconPravdaCoffee"

type Props = {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  value: boolean
  name: string
  id: string
  error?: string
  touched?: FormikTouched<{}>
  variant?: TFormVariant
}

export const AcceptmentField = ({
  value,
  variant = "standart",
  error,
  name,
  touched,
  ...props
}: Props) => {
  const isVariantHalvaDlyaGamerov = variant === "halvaDlyaGamerov"
  const isVariantPravdaCoffee = variant === "pravdaCoffee"

  const iconEmpty = isVariantHalvaDlyaGamerov ? (
    <EmptyIconPink />
  ) : isVariantPravdaCoffee ? (
    <EmptyIconPravdaCoffee />
  ) : (
    <EmptyIcon variant={variant} />
  )
  const iconFilled = isVariantHalvaDlyaGamerov ? (
    <CheckIconPink />
  ) : isVariantPravdaCoffee ? (
    <FilledIconPravdaCoffee />
  ) : (
    <CheckIcon variant={variant} />
  )
  return (
    <WrapperDataLayer isChanged={value} touched={touched} error={error} name={name}>
      <div className={styles.acceptmentWrapper}>
        <div className={styles.acceptment}>
          <div className={clsx(styles.checkbox, styles[variant])}>
            <Checkbox
              color="primary"
              checkedIcon={iconFilled}
              icon={iconEmpty}
              checked={value}
              {...props}
            />
          </div>
          <div>
            <FormHelperText>
              <span className={clsx(styles.acceptmentContent, styles[variant])}>
                Выражаю{" "}
                <AppLinkMui
                  className={clsx(styles.acceptmentLink, styles[variant])}
                  href="https://app.sovcombank.ru/policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="always"
                >
                  согласие
                </AppLinkMui>{" "}
                на&nbsp;обработку персональных данных и&nbsp;подтверждаю, что&nbsp;ознакомлен с
                <AppLinkMui
                  className={clsx(styles.acceptmentLink, styles[variant])}
                  href="https://scb.ru/about/pages/policy-personal-data"
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="always"
                >
                  {" "}
                  Политикой
                </AppLinkMui>{" "}
                обработки персональных данных
              </span>
            </FormHelperText>
          </div>
        </div>
        <FormHelperText error classes={{ root: clsx(styles.acceptmentError, styles[variant]) }}>
          {error}
        </FormHelperText>
      </div>
    </WrapperDataLayer>
  )
}
